<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">

        
        <TaskOverdueFrom />

        <h4>List of Task & Event Statuses</h4>
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <Button
            label="New Status"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          />
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filters"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>

        <ActivityStatusesTable
          :key="activityStatusesTableKey"
          :activityStatuses="activityStatuses"
          :loading="loading"
          @edit-activity-status="editActivityStatus"
        />

        <ActivityStatusForm
          :activityStatusToEdit="activityStatus"
          :key="activityStatusFormKey"
          :activityStatusForm="activityStatusForm"
          :disabledArr="disabledArr"
          :colourCodes="colourCodes"
          @close="hideActivityStatusDialog"
          @save="saveActivityStatus"
        />

      </div>
    </div>
  </div>
</template>

<script>
import ActivityService from "@/service/ActivityService";

import ActivityStatusesTable from './activityStatusesTable'
import ActivityStatusForm from './activityStatusForm'
import TaskOverdueFrom from './TaskOverdueFrom.vue'

export default {
  components: {
    ActivityStatusesTable,
    ActivityStatusForm,
    TaskOverdueFrom
  },
  data: () => ({
    activityService: new ActivityService(),
    filters: '',
    activityStatusesTableKey1: 0,
    activityStatuses: [],
    activityStatus: {},
    activityStatusForm: false,
    activityStatusFormKey1: 0,
    disabledArr: [],
    colourCodes: [
      { id: 1, label: 'Blue', value: 'badge-primary' },
      { id: 2, label: 'Sky Blue', value: 'badge-info' },
      { id: 3, label: 'Gray', value: 'badge-secondary' },
      { id: 4, label: 'Green', value: 'badge-success' },
      { id: 5, label: 'Red', value: 'badge-danger' },
      { id: 6, label: 'Orange', value: 'badge-warning' },
      { id: 7, label: 'White', value: 'badge-light' },
      { id: 8, label: 'Black', value: 'badge-dark' },
    ],
    requesting: false
  }),
  computed: {
    activityStatusesTableKey: {
      set(val) {
        this.activityStatusesTableKey1++
      },
      get() {
        return 'ActivityStatusesTable' + this.activityStatusesTableKey1.toString()
      }
    },
    activityStatusFormKey: {
      set(val) {
        this.activityStatusFormKey1++
      },
      get() {
        return 'ActivityStatusForm' + this.activityStatusFormKey1.toString()
      }
    },
    loading() {
      if (this.activityStatuses && this.activityStatuses[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  created() {
    this.getAllActivityStatuses()
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
  },
  watch: {
    activityStatusForm(val) {
      this.activityStatusFormKey++
    },
    filters(val) {
      this.activityStatusesTableKey++
    },
    activityStatuses(val) {
      if (val && Array.isArray(val)) {
        this.activityStatusesTableKey++
      }
    }
  },
  methods: {
    saveActivityStatus(activityStatus) {
      

      if (activityStatus.id) {
        this.activityService
          .editActivityStatus(activityStatus)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "Status updated",
              detail: "Status updated successfully.",
              life: 5000,
            });
          
            this.activityStatusForm = false
            this.getAllActivityStatuses()
            this.getAllActiveActivityStatusesByHard()
          })
          .catch(err => {
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating the status",
              life: 5000,
            })
          })
      } else {
        this.activityService
          .saveActivityStatus(activityStatus)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "Status saved",
              detail: "Status saved successfully.",
              life: 5000,
            });
          
            this.activityStatusForm = false
            this.getAllActivityStatuses()
            this.getAllActiveActivityStatusesByHard()
          })
          .catch(err => {
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving the status",
              life: 5000,
            })
          })
      }
    },
    hideActivityStatusDialog() {
      this.activityStatus = {}
      this.activityStatusForm = false
    },
    editActivityStatus(activityStatus) {
      this.activityStatus = activityStatus
      this.activityStatusForm = true
    },
    getAllActivityStatuses() {
      this.requesting = true
      this.activityService
        .getAllActivityStatusesByHard()
        .then(data => {
          this.requesting = false

          
          data.forEach(element => {
            if (element.colourCode)
              element.colourCode = this.colourCodes.find(code => code.value === element.colourCode)
          });
          this.activityStatuses = data
        })
        .catch(err => {
          this.requesting = false

          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting activity status",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "activityStatuses"'
          })
        })
    },
    getAllActiveActivityStatusesByHard() {
      this.activityService
        .getAllActiveActivityStatusesByHard()
        .then(data => {})
        .catch(err => {
          
                
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "activeActivityStatuses"'
          })
        })
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    },
    openNew() {
      this.activityStatus = {}
      this.activityStatusForm = true
    }
  }
}
</script>

<style>

</style>